var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { ellipsis, smartQuotes, InputRule } from "prosemirror-inputrules";
import Extension from "../lib/Extension";
var rightArrow = new InputRule(/->$/, "→");
var SmartText = /** @class */ (function (_super) {
    __extends(SmartText, _super);
    function SmartText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SmartText.prototype, "name", {
        get: function () {
            return "smart_text";
        },
        enumerable: true,
        configurable: true
    });
    SmartText.prototype.inputRules = function () {
        return __spreadArrays([rightArrow, ellipsis], smartQuotes);
    };
    return SmartText;
}(Extension));
export default SmartText;
